var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-layout", { staticClass: "title-form", attrs: { row: "" } }, [
        _vm._v("CLIENTE")
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "fill-height": "", wrap: "" } },
        [
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c(
              "p",
              [
                _c("strong", [_vm._v("Nome:")]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: _vm.customerRoute(),
                        params: { id: _vm.order.customer.account.id }
                      }
                    }
                  },
                  [
                    _c("b", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.get(this.order, "customer.account.first_name")
                          ) +
                          "\n            " +
                          _vm._s(
                            _vm.get(this.order, "customer.account.last_name")
                          ) +
                          "\n          "
                      )
                    ])
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            this.order.customer.type === "legals"
              ? _c("p", [
                  _c("strong", [_vm._v("Razão Social:")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.get(this.order, "customer.business_name")) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Email:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "customer.account.email")) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            this.order.customer.type === "legals"
              ? _c("p", [
                  _c("strong", [_vm._v("Nome Fantasia:")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.get(this.order, "customer.company_name")) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Telefone:")]),
              _vm._v(
                "\n        " + _vm._s(_vm.getPhone("customer")) + "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("CPF/CNPJ:")]),
              _vm._v(
                "\n        " + _vm._s(_vm.getCustomerDocument()) + "\n      "
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-layout", { staticClass: "title-form", attrs: { row: "" } }, [
        _vm._v("PROFISSIONAL")
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", "fill-height": "", wrap: "" } },
        [
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c(
              "p",
              [
                _c("strong", [_vm._v("Nome:")]),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to:
                        "/profissionais/" +
                        _vm.get(this.order, "professional.id")
                    }
                  },
                  [
                    _c("b", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.get(
                              this.order,
                              "professional.account.first_name"
                            )
                          ) +
                          "\n            " +
                          _vm._s(
                            _vm.get(
                              this.order,
                              "professional.account.last_name"
                            )
                          ) +
                          "\n          "
                      )
                    ])
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Email:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "professional.account.email")) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md2: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Telefone:")]),
              _vm._v(
                "\n        " + _vm._s(_vm.getPhone("professional")) + "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md2: "", xs12: "" } }, [
            _c("p", [
              _c(
                "a",
                {
                  staticClass: "contrast",
                  attrs: { href: _vm.createInfringementFormlink() }
                },
                [_vm._v("Avisar Atraso")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md2: "", xs12: "" } }, [
            _c("p", [
              _c(
                "a",
                {
                  staticClass: "contrast",
                  attrs: { href: _vm.createCSInfringementFormlink() }
                },
                [_vm._v("Infração")]
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("v-layout", { staticClass: "title-form", attrs: { row: "" } }, [
        _vm._v("LOCAL")
      ]),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Rua:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "address.street")) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs7: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("CEP:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "address.zip_code")) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs5: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Número:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "address.street_number")) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Complemento:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "address.complement")) +
                  "\n      "
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Bairro:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "address.district.display_name")) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs7: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Cidade:")]),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.get(this.order, "address.district.city.display_name")
                  ) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs5: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Estado:")]),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.get(this.order, "address.district.city.state.code")
                  ) +
                  "\n      "
              )
            ])
          ]),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("País:")]),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.get(
                      this.order,
                      "address.district.city.state.country.display_name"
                    )
                  ) +
                  "\n      "
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c("p", [
              _c("strong", [_vm._v("Referência de localização:")]),
              _vm._v(
                "\n        " +
                  _vm._s(_vm.get(this.order, "address.reference")) +
                  "\n      "
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c(
              "p",
              [
                _c("strong", [_vm._v("Geolocalização:")]),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { small: "", outlined: "", color: "primary" },
                    on: {
                      click: function($event) {
                        _vm.showMap = true
                      }
                    }
                  },
                  [_vm._v("mostrar no mapa")]
                ),
                _vm._v(" "),
                _vm.lat && _vm.lng && _vm.showMap
                  ? _c("google-maps", {
                      attrs: {
                        name: "geolocation",
                        lat: _vm.lat,
                        lng: _vm.lng,
                        withAutocomplete: false
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { md3: "", xs12: "", column: "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-layout",
                    { staticClass: "title-form", attrs: { row: "" } },
                    [_vm._v("DIA")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", [
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("formatDate")(
                          _vm.get(this.order, "schedule_event.starts_at"),
                          "dddd, D/M/YYYY"
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md3: "", xs12: "", column: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "title-form", attrs: { row: "" } },
                    [_vm._v("DURAÇÃO")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "" } }, [
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("durationInHous")(
                          _vm.get(this.order, "schedule_event.duration")
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md3: "", xs12: "", column: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "title-form", attrs: { row: "" } },
                    [_vm._v("INÍCIO")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "" } }, [
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("formatDate")(
                          _vm.get(this.order, "schedule_event.starts_at"),
                          "HH:mm"
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md3: "", xs12: "", column: "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-layout",
                    { staticClass: "title-form", attrs: { row: "" } },
                    [_vm._v("STATUS")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm._f("getStatusName")(_vm.get(this.order, "status"))
                    )
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { md3: "", xs12: "", column: "" } },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-layout",
                    { staticClass: "title-form", attrs: { row: "" } },
                    [_vm._v("CRIAÇÃO")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", [
                _c("p", [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm._f("formatDate")(
                          _vm.get(this.order, "created_at"),
                          "dddd, D/M/YYYY HH:mm"
                        )
                      ) +
                      "\n        "
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { md3: "", xs12: "", column: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-layout",
                    { staticClass: "title-form", attrs: { row: "" } },
                    [_vm._v("WIRECARD ID")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-flex", { attrs: { xs12: "" } }, [
                _c(
                  "a",
                  {
                    staticClass: "contrast",
                    attrs: { href: _vm.wirecardUrl, target: "_blank" }
                  },
                  [
                    _c("p", [
                      _vm._v(_vm._s(_vm.get(this.order, "payment_gateway_id")))
                    ])
                  ]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "", column: "" } }),
          _vm._v(" "),
          _c("v-flex", { attrs: { md3: "", xs12: "", column: "" } })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { "align-start": "", row: "" } },
        [
          _c(
            "v-layout",
            {
              attrs: {
                "align-center": "",
                "justify-start": "",
                row: "",
                "fill-heigh": ""
              }
            },
            [
              _c(
                "v-flex",
                [
                  _c("span", { staticClass: "title-form" }, [
                    _vm._v("DESCRIÇÃO")
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { small: "", outlined: "", color: "primary" },
                      on: {
                        click: function($event) {
                          _vm.updatedescription = !_vm.updatedescription
                        }
                      }
                    },
                    [_vm._v("editar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [_c("p", [_vm._v(_vm._s(_vm.get(this.order, "description")))])]
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        {
          attrs: {
            "align-center": "",
            "justify-space-between": "",
            row: "",
            "fill-height": "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            [
              _vm.get(this.order, "status") === "cancelled"
                ? _c("DetailButton", {
                    attrs: {
                      disabled: true,
                      outline: false,
                      imageSrc: "/static/cancel.svg",
                      title: "PEDIDO CANCELADO"
                    }
                  })
                : _c("CancelOrder", {
                    attrs: { order: this.order },
                    on: {
                      refresh: function($event) {
                        return _vm.$emit("refresh")
                      }
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c("DetailButton", {
                attrs: {
                  disabled: !_vm.canReschedule(_vm.order.status),
                  outline: _vm.canReschedule(_vm.order.status),
                  imageSrc: "/static/reschedule.svg",
                  title: "REAGENDAR"
                },
                on: {
                  clicked: function($event) {
                    return _vm.$router.push({
                      name: "rebooking",
                      params: { id: _vm.order.id }
                    })
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.canConfirmPayment
            ? _c(
                "v-flex",
                [
                  _c("ConfirmPayment", {
                    attrs: { order: this.order },
                    on: {
                      refresh: function($event) {
                        return _vm.$emit("refresh")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canSetServiceNotProvided(_vm.order.status)
            ? _c(
                "v-flex",
                [
                  _c("SetServiceNotProvided", {
                    attrs: { order: this.order },
                    on: {
                      refresh: function($event) {
                        return _vm.$emit("refresh")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canRestoreToPaid(_vm.order.status)
            ? _c(
                "v-flex",
                [
                  _c("RestoreOrderToPaid", {
                    attrs: { order: this.order },
                    on: {
                      refresh: function($event) {
                        return _vm.$emit("refresh")
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.updatedescription
        ? _c("UpdateDescription", {
            attrs: { order: this.order },
            on: {
              close: function($event) {
                _vm.updatedescription = false
              },
              refresh: function($event) {
                return _vm.$emit("refresh")
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e30bebc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e30bebc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Orders/ShowOrder/OrderDetails.vue
// module id = null
// module chunks = 